import {
  SET_LEFT_DRAWER_VISIBLE,
  SET_LEFT_DRAWER_CONTENT,
  SET_NOTIFICATIONS_LEFT_DRAWER_VISIBLE,
  SET_NOTIFICATIONS_DRAWER_CONTENT,
  SET_LEFT_DRAWER_COUNTS_FETCH_PATH,
  CLEAR_LEFT_DRAWER,
  SET_LEFT_DRAWER_COUNTS,
} from "../../actions/shared/uiActions";

const _defaultState = {
  visible: false,
  content: "",
  countsFetchPath: "",
  counts: {},
};

export const leftDrawerReducer = (state = _defaultState, action) => {
  Object.freeze(state);

  switch (action.type) {
    case SET_LEFT_DRAWER_VISIBLE:
      return { ...state, visible: action.payload };
    case SET_LEFT_DRAWER_CONTENT:
      return { ...state, content: action.payload };
    case SET_NOTIFICATIONS_LEFT_DRAWER_VISIBLE:
      return { ...state, notificationsVisible: action.payload };
    case SET_NOTIFICATIONS_DRAWER_CONTENT:
      return { ...state, notificationsContent: action.payload };
    case SET_LEFT_DRAWER_COUNTS_FETCH_PATH:
      return { ...state, countsFetchPath: action.payload };
    case SET_LEFT_DRAWER_COUNTS:
      return { ...state, counts: action.payload };
    case CLEAR_LEFT_DRAWER:
      return _defaultState;
    default:
      return state;
  }
};
